// extracted by mini-css-extract-plugin
export default {"modalContent":"UpdateOrderStatusModal_modalContent__-RwgT"};